import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

export const enum ERankTrackerPerformanceOvertimeTabs {
    AVG_WEIGHTED_POSITION = "avgWeightPosition",
    VISIBILITY = "visibility",
    CLICKS = "clicks",
    SHARE_OF_VOICE = "shareOfVoice",
}

export type GranularityItem = {
    title: string;
    value: GranularityNames;
    disabled: boolean;
    tooltipText?: string;
};
